import { render, staticRenderFns } from "./InventoryDocument.vue?vue&type=template&id=11a21bc8&"
import script from "./InventoryDocument.vue?vue&type=script&lang=js&"
export * from "./InventoryDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports